import { cn } from '@/lib/utils';

const PILL_CLASS =
  'truncate rounded-md bg-[#F2F4F7] px-2.5 py-1 text-[12px] font-medium text-[#475467]';

/**
 * One-line capability chips. Every name stays visible; when the row runs out
 * of room the last pill ellipsizes (`Follow-u…`) instead of collapsing into `+n`.
 */
export function OverflowPills({
  items,
  label,
}: {
  items: readonly string[];
  label: string;
}) {
  if (items.length === 0) return null;

  return (
    <div
      className="flex min-w-0 flex-nowrap items-center gap-1.5 overflow-hidden"
      aria-label={label}
    >
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span
            key={item}
            title={item}
            className={cn(
              PILL_CLASS,
              isLast && items.length > 1
                ? 'min-w-0 shrink'
                : 'min-w-0 max-w-full shrink-0'
            )}
          >
            {item}
          </span>
        );
      })}
    </div>
  );
}
